module.exports = __webpack_public_path__ + "img/white.c050f3e5.png";